
const digest = '225a68b4ed024d9ed8c16b2cbfc2a27013697e8d3c74568132cb96ddd2b779e5';
const classes = {"wrapper":"_wrapper_18vp5_1"};
const css = `._wrapper_18vp5_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  